module.exports = __webpack_public_path__ + "img/799.07d07baf.gif";